/* ============================================================
   PLUSHIE PATCH — product display case
   Drag (or swipe, or arrow keys) to turn the product through its
   photos. Pointer tilt and float are decorative and switch off for
   visitors who prefer reduced motion.
   No libraries. Only transform/opacity animate, so it stays cheap.
   ============================================================ */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var stage = document.getElementById('ppStage');
    if (!stage) return;

    var caseEl = document.getElementById('ppCase');
    var views  = [].slice.call(stage.querySelectorAll('.view'));
    var dots   = [].slice.call(stage.querySelectorAll('.angles button'));
    var thumbs = [].slice.call(document.querySelectorAll('.thumbs button'));
    var hint   = document.getElementById('ppHint');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var fine   = window.matchMedia('(hover: hover) and (pointer: fine)');
    var index  = 0;
    var touched = false;

    /* ---------- show a view ---------- */
    function show(i) {
      if (!views.length) return;
      index = (i + views.length) % views.length;
      views.forEach(function (v, n) {
        var on = n === index;
        v.classList.toggle('on', on);
        if (on) { v.removeAttribute('aria-hidden'); } else { v.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('on', n === index);
        d.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      thumbs.forEach(function (t, n) { t.classList.toggle('on', n === index); });
      if (!touched && hint) { touched = true; hint.classList.add('gone'); }
    }

    /* Variant switching (product.js) swaps the first image's src.
       Keep the case in sync by jumping back to that view. */
    var mainImg = document.getElementById('mainImg');
    if (mainImg && window.MutationObserver) {
      new MutationObserver(function () { if (index !== 0) show(0); })
        .observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }

    /* ---------- controls ---------- */
    var prev = document.getElementById('ppPrev');
    var next = document.getElementById('ppNext');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(index - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(index + 1); e.preventDefault(); }
    });

    /* Keep the old thumbnail hook working for anything that calls it */
    window.ppSetImg = function (btn) {
      var n = thumbs.indexOf(btn);
      show(n > -1 ? n : 0);
    };

    /* ---------- drag / swipe to turn ---------- */
    if (views.length > 1) {
      var dragging = false, startX = 0, lastStep = 0, moved = 0;
      var STEP = 42; // pixels of drag per view

      caseEl.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; lastStep = 0; moved = 0;
        caseEl.classList.add('dragging');
        if (e.pointerId && caseEl.setPointerCapture) caseEl.setPointerCapture(e.pointerId);
      });

      caseEl.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        moved = Math.abs(dx);
        var step = Math.round(dx / STEP);
        if (step !== lastStep) { show(index + (step - lastStep)); lastStep = step; }
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        caseEl.classList.remove('dragging');
      }
      caseEl.addEventListener('pointerup', endDrag);
      caseEl.addEventListener('pointercancel', endDrag);
      caseEl.addEventListener('pointerleave', endDrag);
    }

    /* ---------- pointer tilt (desktop, motion allowed) ---------- */
    var tiltOn = stage.getAttribute('data-float') !== 'off';
    if (tiltOn && fine.matches && !reduce.matches) {
      var frame = null, tx = 0, ty = 0;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 2;   // -1 .. 1
        ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!frame) frame = requestAnimationFrame(applyTilt);
      });
      stage.addEventListener('pointerleave', function () {
        tx = 0; ty = 0;
        if (!frame) frame = requestAnimationFrame(applyTilt);
      });
      function applyTilt() {
        frame = null;
        caseEl.style.setProperty('--ry', (tx * 7).toFixed(2) + 'deg');
        caseEl.style.setProperty('--rx', (-ty * 5).toFixed(2) + 'deg');
      }
    }

    /* ---------- run the weather only while the case is on screen ---------- */
    if ('IntersectionObserver' in window && !reduce.matches) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stage.classList.toggle('fx-on', en.isIntersecting); });
      }, { rootMargin: '120px' }).observe(stage);
    }
  });
})();
